export type Link = {
  type: string
  value: string
  isLink: boolean
  href: string
  start: number
  end: number
}
export const formatHardBreaksfromLinks = (links: Link[]): Link[] => {
  const formattedLinks: Link[] = []

  links.forEach((link) => {
    const hrefs = link.href.split('￼')
    link.value.split('￼').forEach((value, index) => {
      formattedLinks.push({
        ...link,
        value,
        href: hrefs[index],
        start: link.start,
        end: value.length,
      })
    })
  })

  return formattedLinks
}
